import React, { useEffect, useMemo, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Assignment from "@material-ui/icons/Assignment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import axios from "../../utils/axiosInstance"; 
import VisibilityIcon from "@material-ui/icons/Visibility";
import Button from "components/CustomButtons/Button.js";
import { Outlet, useNavigate } from "react-router-dom";
import { MantineReactTable } from "mantine-react-table";
import { Box } from "@material-ui/core";
import Pagination from "rc-pagination";
const useStyles = makeStyles(styles);
export default function ManageNotificationTemplate() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [pagination, setPagination] = useState([]);
  console.log(pagination, "pagination")
  const [notificationList, setShowNotificationList] = useState(false);
  useEffect(() => {
    getData(page, limit);
  }, [page, limit, location.pathname]);
  
  const columns = useMemo(() => [
    {
      header: "User Id",
      accessorKey: "userId",
      size: 10,
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return value ? value : "Sent to all users";
      }
    },

    {
      header: "Title",
      accessorKey: "subject",
      size: 10,
    },

    {
      header: "Message",
      accessorKey: "description",
      size: 10,
    },


  ]);
  const getData = async (page = 1, limit = 10) => {
    const token = localStorage.getItem("token");
    console.log(token);
    await axios
      .get(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/notificationhistory`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
          params: {
            page,
            limit,

          },
        }
      )
      .then((res) => {
        console.log(res);
        setNotifications(res.data.data.notifications);
        setPagination(res.data.data.pagination);
      })

      .catch((err) => {
        console.log(err);
        if (err.response.data.message == "For security reasons, we locked your account.Please login to continue") {
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      });
  };


  useEffect(() => {
    if (location.pathname === "/admin/ManageNotificationTemplate") {
      setShowNotificationList(true);
    } else (
      setShowNotificationList(false)
    )
  }, [location.pathname]);
  const updatePage = (newPage) => {
    setPage(newPage);
  };
  return (
    <>
      {notificationList && (<GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                Manage Notification 
              </h4>
              <Button
                color="#3C37FF"
                style={{ float: "right" }}
                onClick={() => navigate("send-notification")}
              >
                send notification
              </Button>
            </CardHeader>
            <CardBody>
              <MantineReactTable
                columns={columns}
                displayColumnDefOptions={{
                  "mrt-row-actions": {

                    mantineTableHeadCellProps: {
                      align: "center",

                    },
                    size: 120
                  }
                }}
                enableColumnFilterModes
                enablePagination={false}
                enableFullScreenToggle={false}
                enableHiding={false}
                enableDensityToggle={false} 
                enableFilters={ false}
                initialState={{ showColumnFilters: false }}
                positionToolbarAlertBanner="bottom"
                data={notifications}
                renderRowActionMenuItems={({ row }) => [
                  {
                    label: "View",
                    icon: <VisibilityIcon />,
                    onClick: () => {
                      console.log(row);
                    },
                  }
                ]}
                positionActionsColumn="first"

              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "20px",
                }}
              >
                <Pagination
                  pageSize={pagination?.limit || 10}
                  current={pagination?.page || 1}
                  total={pagination?.totalPages || 0}
                  onChange={updatePage}
                />
              </Box>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>)}
      <Outlet /></>
  );
}
